module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/benchmarks.json
// module id = 356
// module chunks = 6876176084528